import { Controller } from "@hotwired/stimulus"
import { Datepicker } from "flowbite-datepicker"
import ro from "../../../node_modules/flowbite-datepicker/js/i18n/locales/ro.js";

export default class extends Controller {
  static targets = ["dateInput", "datePicker"]

  connect() {
    const minDate = this.datePickerTarget.dataset.minDate
    const maxDate = this.datePickerTarget.dataset.maxDate
    this.minDate = this.parseDate(minDate)
    this.maxDate = this.parseDate(maxDate)

    Datepicker.locales.ro = ro.ro

    this.datepicker = new Datepicker(this.datePickerTarget, {
      language: 'ro',
      format: 'yyyy-mm-dd',
      autohide: true,
      minDate: minDate,
      maxDate: maxDate,
    })

    this.handleChangeDate = ({ detail }) => {
      if (!detail.date) return

      this.applyDate(detail.date, { updatePicker: false })
    }

    this.datePickerTarget.addEventListener('changeDate', this.handleChangeDate)
  }

  quickSet(event) {
    event.preventDefault()
    const { date, offset } = event.currentTarget.dataset
    let targetDate = null

    if (date) {
      targetDate = this.parseDate(date)
    } else if (offset) {
      const baseDate = this.parseDate(this.dateInputTarget.value) ||
        this.parseDate(this.datePickerTarget.value) ||
        new Date()
      targetDate = new Date(baseDate)
      targetDate.setDate(baseDate.getDate() + Number(offset))
    }

    if (!targetDate || Number.isNaN(targetDate.getTime())) return

    this.applyDate(this.clampDate(targetDate), { updatePicker: true })
  }

  clampDate(date) {
    let nextDate = date
    if (this.minDate && nextDate < this.minDate) nextDate = new Date(this.minDate)
    if (this.maxDate && nextDate > this.maxDate) nextDate = new Date(this.maxDate)
    return nextDate
  }

  applyDate(date, { updatePicker } = { updatePicker: true }) {
    const formattedDate = this.formatDate(date)
    this.dateInputTarget.value = formattedDate
    this.datePickerTarget.value = formattedDate

    if (updatePicker && this.datepicker) {
      this.datepicker.setDate(date, { render: true, autohide: true })
    }

    this.dateInputTarget.dispatchEvent(new InputEvent('input', { bubbles: true }))
  }

  parseDate(dateString) {
    if (!dateString) return null
    const parts = dateString.split('-').map(Number)
    if (parts.length !== 3) return null
    const [year, month, day] = parts
    const date = new Date(year, month - 1, day)
    if (Number.isNaN(date.getTime())) return null
    return date
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  disconnect() {
    if (this.datepicker) {
      this.datepicker.destroy()
    }

    this.datePickerTarget.removeEventListener('changeDate', this.handleChangeDate)
  }
}
